export default __webpack_public_path__ + "static/media/Logo-White.ba14f260.png";